var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_232_11791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 7.35779V17.9541C19.9999 19.6697 18.6999 20.9816 16.9999 20.9816H5.8999C5.8999 22.0917 6.7999 23 7.8999 23H17.9999C20.1999 23 21.9999 21.1835 21.9999 18.9633V9.37614C21.9999 8.26604 21.0999 7.35779 19.9999 7.35779Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 1V3.01835H4C2.9 3.01835 2 3.92661 2 5.0367V17.1468C2 18.2569 2.9 19.1651 4 19.1651H16.2C17.3 19.1651 18.2 18.2569 18.2 17.1468V5.0367C18.2 3.92661 17.3 3.01835 16.2 3.01835H15.2V1H13.2V3.01835H7V1H5ZM4 8.06422H16.2V17.1468H4V8.06422Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 16.3395L11.3 14.9267L9 16.3395L9.6 13.6147L7.5 11.7982L10.3 11.5964L11.4 8.97253L12.5 11.4955L15.3 11.7982L13.2 13.6147L13.7 16.3395Z",
    fill: "#9E9E9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_232_11791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.80dedf87b5c5f3229be2935bea338a44.svg";
export { ForwardRef as ReactComponent };